<!-- 头部 -->
<template>
  <div class="top f20 pL10 fb relative">
    <div @click="titleClick">
      <img style='height: 25px; width: auto;' src="../../static/images/aon.png"/><span class="fn f16" style="color: #000"> powered by </span><span style="color: #c90a5b;" >Red</span><span style="color: #000">Wealth</span>
    </div>
    <i v-show="showIcon" class="iconfont cursor color-primary absolute tools icon-gongju f28"
    @click.stop="show3 = !show3" style="left: 125px;"></i>
    <div style="margin-top: -15px; margin-left: 100px;" v-show="routerName !== 'Login'" class="tools">
      <el-collapse-transition>
        <div v-show="show3" class="absolute">
          <div class="transition-box">
            <div class="icon-div cursor" :class="{ 'active-item': routerName == 'ClientManage' }" @click="toClientManage">
              <i class="iconfont mr-10 color-primary icon-renyuanpeixunguanli"></i>客户管理
            </div>
            <!-- <div class="icon-div cursor"><i class="iconfont mr-10 color-primary icon-107"></i>财富规划</div>
            <div class="icon-div cursor"><i class="iconfont mr-10 color-primary icon-zichanguanli"></i>投资管理</div>
            <div class="icon-div cursor"><i class="iconfont mr-10 color-primary icon-jinrongxueyuan"></i>金融教育</div>
            <div class="icon-div cursor"><i class="iconfont mr-10 color-primary icon-chanpin"></i>产品管理</div> -->
          </div>
        </div>
      </el-collapse-transition>
    </div>
    <div @mouseenter="show = true" @mouseleave="show = false" v-show="routerName !== 'Login' && routerName !== 'SignUp'">
      <span class="iconfont icon-yonghu4-copy absolute f28 cursor" style="right: 15px; top: 0px; color: #c90a5b;"></span>
      <!-- <span class="iconfont icon-yonghu4-copy absolute f28 cursor" style="right: 15px; top: 0px; color: #c90a5b;" v-show="routerName !== 'Login'"></span> -->
      <!-- <div class="mt-5 mr-10 fr toolAccount"> -->
      <el-collapse-transition>
        <div class="account-box" v-show="show">
          <!-- <div class="cursor accout-div account-name"><i class="iconfont mr-10 icon-yonghu"></i>个人信息</div> -->
          <!-- <div class="cursor accout-div reset-password" @click="toResetPassword" :class="{ 'active-forget-password': routerName == 'ResetPassword' }"><i class="iconfont mr-10 icon-xiugaimima"></i>修改密码</div> -->
          <!-- <div class="cursor accout-div"><i class="iconfont mr-10 icon-107"></i>上传X X</div> -->
          <div class="cursor logout-div accout-div" @click="logout"><i class="iconfont mr-10 icon-tuichu1"></i>退出登录</div>
        </div>
      </el-collapse-transition>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      show: false,
      show3: false,
      routerName: '',
      salesFlag: false
    }
  },
  components: {},
  computed: {
    showIcon () {
      return this.routerName !== 'Login' && this.routerName !== 'SignUp' && this.salesFlag === 'true'
    }
  },
  mounted () {
    this.routerName = this.$route.name
    this.salesFlag = localStorage.getItem('sales_flag')
    // console.log(this.$route.name)
    document.addEventListener('click', (e) => {
      if (e.target.className !== 'tools') {
        this.show3 = false
      }
    })
  },
  methods: {
    toClientManage () {
      this.$router.push({ name: 'ClientManage' })
    },
    titleClick () {
      this.$router.push({ name: 'Login' })
    },
    logout () {
      this.$router.push({ name: 'Login' })
      window.localStorage.removeItem('token')
    },
    toResetPassword () {
      this.$router.push({ name: 'ResetPassword' })
    }
  }
}
</script>

<style>
.top {
  height: 60px;
  line-height: 60px;
  background: #fff;
}

.transition-box {
  /* margin-bottom: 10px; */
  width: 120px;
  /* height: 100px; */
  /* border-radius: 5px; */
  /* background-color: #409EFF; */
  text-align: center;
  color: #000;
  /* padding: 40px 20px; */
  box-sizing: border-box;
  z-index: 999;
  position: relative;
  /* margin-right: 20px; */
}

.icon-div {
  border: 1px solid #c90a5b;
  border-radius: 10px;
  font-size: 15px;
  height: 35px;
  line-height: 33px;
  padding: 0px 10px;
  margin-bottom: 7px;
  background: #efefef;
}

.icon-div:hover,
.active-item {
  background: #fff;
  color: #c90a5b;
  font-size: 16px;
}

.account-box {
  border: 1px solid #c90a5b;
  border-radius: 8px;
  background: #efefef;
  width: 115px;
  position: absolute;
  right: 15px;
  top: 50px;
}

/* .logout-div {
  border-top: 1px solid gray;
} */

.account-name {
  border-bottom: 1px solid gray;
}

.accout-div {
  padding: 0 10px;
  font-size: 14px;
  line-height: 30px;
}

/* .reset-password:hover { */
/* border-radius: 8px 8px 0 0; */
/* } */

.logout-div:hover {
  border-radius: 0 0 8px 8px;
}

.accout-div:hover,
.active-forget-password {
  background: #c90a5b;
  color: #fff !important;
}

/* .account-box>.iconfont:hover{
  color: #fff!important;
} */
/* .el-step__icon.is-icon{
  margin-left: 10px;
} */
</style>



// WEBPACK FOOTER //
// src/components/Header.vue